import React from 'react';
import MembersApi from '../../../../services/portal-api/MembersApi';
import moment from "moment/moment";
import swal from 'sweetalert';

export default class WdayVoucherJob extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            retrying: false,
            marking: false,
            jobId: this.props.jobDetails.id,
            data: {},
        }
        this._runJob = this._runJob.bind(this);
    }

    componentDidMount(){
        const data = this.state.data;
        data["rewards_card_number"] = this.props.jobDetails.gift_card_number;
        data["email"] =  this.props.jobDetails.customer_email;
        data["created_at"] =  this.convertUTCToLocalTime(this.props.jobDetails.created_at);
        data["is_eligible"] =  this.props.jobDetails.is_eligible;
        data["is_exported"] =  this.props.jobDetails.is_exported;
        data["is_complete"] = this.props.jobDetails.is_complete;
        this.setState({
            data : data
        });
    }
    
    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds(),
        );
        const localTime = new Date(milliseconds);
        let cd = localTime.getFullYear()+"-"+(localTime.getMonth()+1)+"-"+localTime.getDate()+" "+localTime.getHours()+":"+localTime.getMinutes()+":"+localTime.getSeconds();
        return moment(cd).format('DD/MM/YYYY h:mm A');
    };

    _runJob(event){
        this.setState({
            retrying: true   
        });  

        this.props.Job(this.state.jobId,'welcome_promo',() => {
            MembersApi.getJobs((response)=>{
              if(response.success){

                  const data = this.state.data;
                  data["rewards_card_number"] = response.json.result.gift_card_number;
                  data["email"] =  response.json.result.customer_email;
                  data["created_at"] =  this.convertUTCToLocalTime(response.json.result.created_at);
                  data["is_eligible"] =  response.json.result.is_eligible;
                  data["is_exported"] =  response.json.result.is_exported;
                  data["is_complete"] = response.json.result.is_complete;

                  this.setState({
                  data : data,  
                  retrying: false   
                  },()=>{console.log(this.state)});

              } else {
                if(response.status === 401){
                    this.props.wdaySessionLogger(response);
                } else {
                    // alert("Sorry, Unable to fetch job status");
                    swal("Sorry, Unable to fetch job status", {
                        icon: "warning",
                        buttons: false,
                        timer: 3000
                    });
                }
              }     
            },'welcome_promo',this.state.jobId);

        });
    }

    _markJob = (event) => {
        this.setState({
            marking: true   
        },()=>{
            MembersApi.markTheJobs((response)=>{
                if(response.success){
                    
                    MembersApi.getJobs((response)=>{
                        if(response.success){
            
                            const {data} = this.state;
                            data["is_complete"] =  response.json.result.is_complete;
                            data["is_eligible"] =  response.json.result.is_eligible;
                            data["is_exported"] =  response.json.result.is_exported;
                            this.setState({
                            data : data,  
                            marking: false   
                            },()=>{console.log("mark",this.state)});
            
                        } else {
                            // alert("Sorry, Unable to fetch job status");
                            swal("Sorry, Unable to fetch job status", {
                                icon: "warning",
                                buttons: false,
                                timer: 3000
                            });
                        }     
                    },'welcome_promo',this.state.jobId);
                    
                } else {
                    if(response.status === 401){
                        this.props.wdaySessionLogger(response);
                    } else {
                        // alert("Sorry, Unable to fetch job status");
                        swal("Sorry, Unable to fetch job status", {
                            icon: "warning",
                            buttons: false,
                            timer: 3000
                        });
                    }
                }  
            },this.state.jobId,'welcome_promo');
        });
    }

    render(){
        let status = this.state.retrying ? "Retrying" : "Retry";
        let details = "admintools/jobs/"+this.state.jobId+"/welcome_promo";
        return (<tr>
            <td><strong><a href={details} target="_blank" style={{color:"#21a573"}}>{this.state.data.rewards_card_number}</a></strong></td>
            <td style={{width:'19%',wordBreak:'break-all'}}>{this.state.data.email}</td>
            <td>{this.state.data.created_at}</td>
            <td>{this.state.data.is_eligible ? "Yes": "No"}</td>
            <td>{this.state.data.is_exported ? "Yes": "No"}</td>
            <td>{this.state.data.is_complete ? "Complete": "Incomplete"}</td>
            <td>{this.state.data.is_complete == 0 && <button className="btn btn--xsmall btn--open" onClick={this._runJob}> {status} {this.state.retrying && <img className="icon" src="/img/Gear-job.gif" style={{width:20,height:20,top:"34%",marginTop:-5,right:8}}></img>}</button>}
            {this.state.data.is_complete != 0 && <span> ---- </span>}
            </td>
            </tr>);
    }
}